import { format } from 'date-fns';
import 'regenerator-runtime/runtime'
import { pagamentoNonElettronico } from '../api/pagamenti';

import { nextUrlByStep } from "../components/preventivo/frammenti/FrammentoRiepilogo";
import { convertiFormRequestCalcola } from "../components/preventivo/Preventivo";
import useBSSLogger from "../hooks/useBSSLogger";
import __t from "./traduzioni";

const {logger} = useBSSLogger();

const statoPagamentoIncorso = {mostra: true, messaggio: `${__t("attendere")} ${__t("pagamentoincorso")}`}


function preventDefault({event}){
    return event.preventDefault();
}

function retrieveIdModPag({modalita}){
    return modalita.id;
}

async function triggerValidazione({methods}){
    return await methods.trigger()
}

function createRequest({methods, idmodpag, carrelloStorage}){
    const {datifatt: datiFatturazione} = methods.getValues();
    const datiCarrello = {
        carrello: {
            preventivi: carrelloStorage.preventivi.map(convertiFormRequestCalcola),
            datiFatturazione
        },
        idmodpag
    }
    return datiCarrello;
}

async function preExecRequest() {}

//devo fare il redirect alla pagina di pagamento di paypal passando tutti i dati necessari
async function preExecRequestPaypal({datiCarrello, carrelloStorage, modalita, apriPagamentoInCorso, chiudiPagamentoInCorso, ...ppparams}){

    await pagamentoNonElettronico(datiCarrello)

    const mappaParametri = Object.entries(ppparams).reduce((obj, [k, {valore, tipo}]) => {
        obj[k] = tipo.value === 'B' ? (valore === 'true' ? true : false) : valore ;
        return obj;
    }, {})

    logger.debug("procedura pagamento paypal", datiCarrello, carrelloStorage, modalita, ppparams, mappaParametri);

    let {
        actionurl,//url da aprire al netto dei parametri in query string
        email,//email dell'account paypal del seller
        notify_url,//url di ipn, paypal contatterà questo url 
        cmd,//tipo di operazione
        currency_code,
        paymentaction,    
        chiaveImponibile, //nome del campo che conterrà l'imponibile    
        item_name,//prodotto che il buyer sta acquistando
        protezioneVendite//boolean che indica se attiva la protezione vendita, se true vengono inviati più dettagli
    } = mappaParametri;    
    
    const urlSuccess = new URL(location.href);
    urlSuccess.searchParams.delete("paypalResult");
    urlSuccess.searchParams.delete("PayerID");
    urlSuccess.searchParams.append("paypalResult", "success");    

    const urlError = new URL(location.href);
    urlError.searchParams.delete("paypalResult");
    urlError.searchParams.delete("PayerID");
    urlError.searchParams.append("paypalResult", "error");

    let dati = {
        business: email,
        notify_url,
        cmd,
        currency_code,
        paymentaction,
        return: urlSuccess.href,
        cancel_return: urlError.href,
        item_name,
        charset: 'utf-8',
        no_note: 1,
        quantity: 1,
        [chiaveImponibile]: modalita.imponibile,
        tax: modalita.iva,
        invoice: carrelloStorage.db.id// + Number(format(new Date(), "T"))
    }

    if(protezioneVendite){
        const {datiFatturazione} = datiCarrello.carrello;
        const {tipopersona} = datiFatturazione.anagrafica ?? datiFatturazione.gruppo;
        const {ragionesociale, nome, cognome, citta, cap, civico, indirizzofatturazione, nazione} = datiFatturazione;
        
        let datiProtezioneVendite = {
            address_override: true,
            showShippingAddress: false,
            address1: `${indirizzofatturazione} ${civico}`,
            city: citta,
            zip: cap,
            country: nazione.iso,
            last_name: ragionesociale ?? cognome,
        }    
        
        if(['FISICA', 'FISICAI'].includes(tipopersona.value)){
            datiProtezioneVendite.first_name = nome;
        }
    
        dati = {...dati, ...datiProtezioneVendite}
    }

    const searchParams = new URLSearchParams(dati);

    const completeUrl = `${actionurl}?${searchParams.toString()}`

    logger.debug("faccio il redirect a", actionurl, "passando", dati)
    
    location.href = completeUrl;

    //dopo il redirect blocco tutto, non devo andare oltre 
    throw(new Error(__t("paypalfase1end")))


}

async function preExecRequestStripe({datiCarrello, stripe, elements, apriPagamentoInCorso, chiudiPagamentoInCorso}) {

    if(!elements){
        chiudiPagamentoInCorso()
        throw(new Error(__t("stripenotloaded")))
    }

    await pagamentoNonElettronico(datiCarrello)

    const {error} = await stripe.confirmPayment({elements: elements, redirect: "if_required"});
    if(error){
        chiudiPagamentoInCorso()
        throw(error)
    }
}

async function execRequest({preExecRequest, preExecRequestParams, execPayment, datiCarrello, carrelloStorage, modalita, apriPagamentoInCorso, chiudiPagamentoInCorso}){
    await preExecRequest({...preExecRequestParams, datiCarrello, carrelloStorage, modalita, apriPagamentoInCorso, chiudiPagamentoInCorso})
    return await execPayment(datiCarrello)
}

function clearStorage({rimuoviPreventivoStorage, rimuoviCarrelloStorage}){
    rimuoviPreventivoStorage();
    rimuoviCarrelloStorage();
}

function createNotifies(){
    return [{tipo: "success", messaggio: __t("ordinecreatosuccess")}]
}

function createNotifiesPaypal(){
    return [{tipo: "success", messaggio: __t("attesaverificapaypal")}]
}

function redirectSuccess({flashMessages}) {
    location.href = nextUrlByStep(5, flashMessages)
}

//esegue il pagamento al momento richiamato al click su paga fine mese, paga con bonifico e paga con carta (stripe) @todo implementare per paypal
async function execute({event, modalita, methods, execPayment, carrelloStorage, rimuoviCarrelloStorage, rimuoviPreventivoStorage, specificPreExecRequest, preExecRequestParams, backdropPreventivo, setBackdropPreventivo, specificNotifier}){
    
    const chiudiPagamentoInCorso = () => setBackdropPreventivo({mostra: false, messaggio: null});
    const apriPagamentoInCorso = () => setBackdropPreventivo(statoPagamentoIncorso);
    
    //mostro backdrop così da non permette all'utente di ricliccare
    apriPagamentoInCorso();

    //blocco eventuali propagazioni di eventi al submit del form
    preventDefault({event});

    //ottento l'id dalla modalità di pagamento
    const idmodpag = retrieveIdModPag({modalita});

    //eseguo la validazione sul form, così da evidenziare in rosso eventuali campi non validi
    const formValido = await triggerValidazione({methods});

    //se il form non è valido chiudo il backdrop ed esco dall'esecuzione del pagamento
    if(!formValido) {
        chiudiPagamentoInCorso()
        return;
    }

    //dal carrello in storage ottengo i dati del carrello
    const datiCarrello = createRequest({methods, idmodpag, carrelloStorage});   
    
    try{
        //eseguo eventuali operazioni prima del pagamento, quindi effettuo il pagamento
        await execRequest({preExecRequest: specificPreExecRequest ?? preExecRequest, preExecRequestParams, execPayment, datiCarrello, carrelloStorage, modalita, apriPagamentoInCorso, chiudiPagamentoInCorso});
    } catch(err){
        //se qualcosa dovesse andare storto durante il pagamento chiudo la backdrop e inoltro l'errore così da gestirlo in maniera standard
        chiudiPagamentoInCorso();
        throw(err);
    }


    const eventoPreventivatore = new CustomEvent("spedizioniweb2_step_4", {
        detail: {//@todo definire dati da passare all'evento
            modalita,
            carrelloStorage,
            data: methods.getValues()
        }
    });
    document.dispatchEvent(eventoPreventivatore);

    //se sono arrivato qui, il pagamento è andato a buon fine, posso pulire lo storage del browser
    clearStorage({rimuoviPreventivoStorage, rimuoviCarrelloStorage})

    //creo i flashmessage di successo 
    const flashMessages = (specificNotifier ?? createNotifies)();

    //faccio il redirect alla pagina degli ordini passando i messaggi di successo
    redirectSuccess({flashMessages})
}

export {    
    preExecRequestStripe,
    preExecRequestPaypal,
    createNotifiesPaypal,
    execute
} 